import groupBy from 'lowscore/groupBy.js'
import values from 'lowscore/values.js'
import LocalDate from '@booking-services/localDate'

function sortCommissionPolicies ({commissionPolicies, departureDate}) {
  let effectivePolicies = commissionPolicies
    .filter(insideBookingWindow)
    .filter(insideTravelWindow.bind(null, departureDate))

  return skipOlderDuplicatePolicies( effectivePolicies ) .map(assignSpecificity) .sort(moreSpecificPoliciesFirst)
}

function insideBookingWindow (policy) {
  var now = new LocalDate()

  return (
    (!policy.policyEffectiveToDate || policy.policyEffectiveToDate >= now) &&
    policy.policyEffectiveFromDate <= now
  )
}

function insideTravelWindow (departureDate, policy) {
  var [policyStartsBefore, policyEndsAfter] = [true, true]

  if (policy.policyTravelPeriodFromDate) {
    policyStartsBefore = policy.policyTravelPeriodFromDate <= departureDate
  }
  if (policy.policyTravelPeriodToDate) {
    policyEndsAfter = policy.policyTravelPeriodToDate >= departureDate
  }
  return policyStartsBefore && policyEndsAfter
}

function skipOlderDuplicatePolicies (policies) {
  return values(
    groupBy(policies, policy => {
      let key =
        (policy.productCode || '_') +
        (policy.productBrochureCode || '_') +
        (policy.productTypeCode || '_') +
        (policy.bookingChannelCode || '_') +
        (policy.productClassificationId || '_') +
        (policy.productCategory || '_')

      return key
    })
  ).map(policyGroup => {
    let policy = policyGroup.sort((a, b) => {
      return b.policyEffectiveFromDate - a.policyEffectiveFromDate || b.lastModifiedDate - a.lastModifiedDate
    })[0]
    return policy
  })
}

function moreSpecificPoliciesFirst (a, b) {
  if (a.specificity != b.specificity) {
    return a.specificity - b.specificity
  }
  return !!b.bookingChannelCode - !!a.bookingChannelCode
}

function assignSpecificity (p) {
  if (p.productCode) {
    p.specificity = 1
  } else if (
    p.productBrochureCode &&
    p.productTypeCode &&
    p.productClassificationId &&
    p.productCategory
  ) {
    p.specificity = 2
  } else if (p.productBrochureCode && p.productTypeCode && p.productCategory) {
    p.specificity = 3
  } else if (
    p.productBrochureCode &&
    p.productTypeCode &&
    p.productClassificationId
  ) {
    p.specificity = 4
  } else if (p.productBrochureCode && p.productTypeCode) {
    p.specificity = 5
  } else if (p.productBrochureCode) {
    p.specificity = 6
  } else if (p.productTypeCode && p.productCategory) {
    p.specificity = 7
  } else if (p.productTypeCode && p.productClassificationId) {
    p.specificity = 8
  } else if (p.productTypeCode) {
    p.specificity = 9
  } else {
    p.specificity = 10
  }
  return p
}

export default sortCommissionPolicies
